
export type ApiCaseRecord = {
  id: string;
  caseNumber: string;
  name: string;
  city: string;
  state: string;
  sportAffiliations: string;
  misconduct: string;
  actionTaken: string;
  additionalDetail: string;
  dateOfIssuance: string;
  adjudicatingBody: string;
  sourceCreatedAt?: string;
  sourceLastUpdatedAt?: string;
};

export type CaseRecord = ApiCaseRecord;

export type CaseFilters = {
  city: string;
  state: string;
  sportAffiliation: string;
  adjudicatingBody: string;
};

export type FilterOptions = {
  cities: string[];
  states: string[];
  sportAffiliations: string[];
  adjudicatingBodies: string[];
};

export type Pagination = {
  page: number;
  pageSize: number;
  totalRows: number;
  totalPages: number;
};

export type ApiResponse = {
  lastModified?: string;
  data?: ApiCaseRecord[];
  filters?: FilterOptions;
  pagination?: Pagination;
};

export type SortOrder = {
  name: string;
  direction: 'asc' | 'desc';
};

export type ColumnKey = keyof Pick<
  CaseRecord,
  | "name"
  | "city"
  | "state"
  | "sportAffiliations"
  | "misconduct"
  | "actionTaken"
  | "additionalDetail"
  | "dateOfIssuance"
  | "adjudicatingBody"
>;

export type ColumnConfig = {
  key: ColumnKey;
  label: string;
  width: string;
  align?: "left" | "center" | "right";
};

export const PAGE_SIZE_OPTIONS = [10, 25, 50];
